import type { ITextComponentProperties } from '@sharedInterfaces/IEmployeeTalkTemplate';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import FormatedTextInput from '@src/App/Components/General/FormularElements/formsControls/inputs/FormatedTextInput/FormatedTextInput';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';

import type { ITemplateComponentProps } from '../TemplateEditor/types';

import ETTBaseTemplateComponent from './ETTBaseTemplateComponent';

export interface IETTTextComponentProps extends ITemplateComponentProps {}

export const ETTTextComponent: React.FC<IETTTextComponentProps> = (props) => {
    const { component } = props;
    const properties = component.properties as ITextComponentProperties;
    const text = properties.text || '';

    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).employeeTalk;

    return (
        <ETTBaseTemplateComponent
            {...props}
            renderEditContent={() => (
                <FormatedTextInput
                    fullWidth
                    value={text}
                    onChange={(value) => {
                        if (props.onEdit) {
                            props.onEdit({
                                ...component,
                                properties: {
                                    ...properties,
                                    text: value,
                                } as ITextComponentProperties,
                            });
                        }
                        if (props.onChange) {
                            props.onChange(value);
                        }
                    }}
                />
            )}
            renderViewContent={() => <FormatedTextInput fullWidth value={text} readonly />}
        />
    );
};

export default ETTTextComponent;
